import { motion, AnimatePresence } from 'framer-motion'
import { X, CheckCircle, AlertCircle, Info } from 'lucide-react'
import { useUIStore } from '@/stores/uiStore'

const icons = {
  success: CheckCircle,
  error: AlertCircle,
  info: Info,
}

export function ToastContainer() {
  const { toasts, removeToast } = useUIStore()

  return (
    <div className="fixed bottom-6 right-6 z-[100] flex flex-col gap-3">
      <AnimatePresence>
        {toasts.map((toast) => {
          const Icon = icons[toast.type ?? 'info']
          return (
            <motion.div
              key={toast.id}
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 8 }}
              className="flex items-center gap-3 rounded-sm border border-ink/10 bg-paper px-4 py-3 shadow-2xl"
            >
              <Icon className="h-4 w-4 text-wd-orange" />
              <span className="text-sm text-carbon">{toast.message}</span>
              <button
                onClick={() => removeToast(toast.id)}
                className="text-carbon/40 hover:text-wd-orange"
                aria-label="Dismiss"
              >
                <X className="h-4 w-4" />
              </button>
            </motion.div>
          )
        })}
      </AnimatePresence>
    </div>
  )
}
